(() => {
  if (customElements.get('mimosa-quote')) return;
  class MimosaQuote extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.form = this.querySelector('form');
      this.link = this.querySelector('[data-quote-link]');
      this.embroidery = this.form.elements.embroidery;
      this.fabric = this.form.elements.fabric;
      this.quantity = this.form.elements.quote_quantity;
      this.detail = this.form.elements.embroidery_detail;
      this.detailWrapper = this.querySelector('[data-embroidery-detail]');
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.link.addEventListener('click', (event) => {
        this.update();
        if (!this.form.reportValidity()) event.preventDefault();
      });
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.link.click();
      });
      this.update();
    }
    update() {
      const showDetail = this.embroidery.selectedIndex > 1;
      this.detailWrapper.hidden = !showDetail;
      this.detail.disabled = !showDetail;
      const lines = [
        this.dataset.greeting,
        this.dataset.title,
        this.dataset.embroideryLabel + ': ' + this.embroidery.value,
        this.dataset.fabricLabel + ': ' + this.fabric.value,
        this.dataset.quantityLabel + ': ' + this.quantity.value
      ];
      if (showDetail && this.detail.value.trim()) {
        lines.push(this.dataset.detailLabel + ': ' + this.detail.value.trim());
      }
      const productInfo = this.closest('product-info');
      if (productInfo) {
        productInfo.querySelectorAll('variant-selects select, variant-selects input[type="radio"]:checked').forEach((input) => {
          if (input.value) lines.push(input.value);
        });
      }
      lines.push(this.dataset.request, this.dataset.url);
      this.link.href = 'https://wa.me/34604995068?text=' + encodeURIComponent(lines.join('\n'));
    }
  }
  customElements.define('mimosa-quote', MimosaQuote);
})();
